import axios from "axios";
import { Base64 } from "js-base64";
import { FIS_BACKEND, ucp_BACKEND } from "./default";
import { authHeader } from "./authHeader";
// import { NotificationManager } from "react-notifications";

const admintomanger = JSON.parse(localStorage.getItem("admintomanger"));
const admintomangerjson = admintomanger && admintomanger.split("-");
const adminToMangerOutletName =
  admintomangerjson && admintomangerjson[0].trim();
const adminToMangerOutletCode =
  admintomangerjson && admintomangerjson[1].trim();
const adminToMangerCompanyCode =
  admintomangerjson && admintomangerjson[2].trim();

const username1 = "adhithyan.m@clsslabs.com";
const password1 = "adhithyan";
const base64 = require("base-64");
const APIKEY_TOKEN = "ad0cbb90a252228927e5bb6f6cff15dc";

export const getoutletListMaster = async (companyCode) => {
  try {
    const getoutletmaslist = await axios.get(
      `${FIS_BACKEND}/getAllOutlet?companyCode=${
        adminToMangerCompanyCode || companyCode
      }`,
      {
        headers: authHeader(),
      }
    );
    return getoutletmaslist;
  } catch (error) {
    return error.response;
  }
};

export const outletTurnOnOffApi = async (outletCode, status) => {
  try {
    const getoutletmaslist = await axios.post(
      `${FIS_BACKEND}/updateOutletStatus?outletCode=${
        adminToMangerOutletCode || outletCode
      }&status=${status}`,
      {},
      {
        headers: authHeader(),
      }
    );
    return getoutletmaslist;
  } catch (error) {
    return error.response;
  }
};

export const TemplateSaveMaster = async (data) => {
  
  console.log("data", data);
  try {
    const getoutletmaslist = await axios.post(
      `${FIS_BACKEND}/saveWhatsappTemplate`,
      data,

      {
        headers: authHeader(),
      }
    );
    return getoutletmaslist;
  } catch (error) {
    return error.response;
  }
};

export const getCompanyListMaster = async () => {
  try {
    const getoutletmaslist = await axios.get(`${FIS_BACKEND}/getCompanyList`, {
      headers: authHeader(),
    });
    return getoutletmaslist;
  } catch (error) {
    return error.response;
  }
};

export const getApprovalTemplateListMaster = async () => {
  try {
    const getoutletmaslist = await axios.get(`${FIS_BACKEND}/getBroadcastListByApproveFlag?approveFlag=A`, {
      headers: authHeader(),
    });
    return getoutletmaslist;
  } catch (error) {
    return error.response;
  }
};

export const getRoleMaster = async () => {
  try {
    const roleList = await axios.get(`${FIS_BACKEND}/api/auth/roleList`, {
      headers: authHeader(),
    });
    return roleList;
  } catch (error) {
    return error.response;
  }
};

export const getAdminRoleMaster = async (roleId) => {
  try {
    const adminroleList = await axios.get(
      `${FIS_BACKEND}/api/auth/getUsersListByRole?roleId=${roleId}`,
      {
        headers: authHeader(),
      }
    );
    return adminroleList;
  } catch (error) {
    return error.response;
  }
};

export const getCustomerMasterlist = async () => {
  // console.log("getCustomerMasterlist", getCustomerMasterlist);
  try {
    const CustomerMasterlist = await axios.get(`${FIS_BACKEND}/getCustomers`, {
      headers: authHeader(),
    });
    return CustomerMasterlist;
  } catch (error) {
    return error.response;
  }
};

export const saveoutletDetails = async (data) => {
  let user = JSON.parse(localStorage.getItem("userDetails"));
  try {
    const saveoutletDetailsData = await axios.post(
      `${FIS_BACKEND}/addOutlet`,
      data,
      {
        headers: {
          "Content-Type": "multipart/form-data",
          Authorization: "Bearer " + user.accessToken,
        },
      }
    );
    return saveoutletDetailsData;
  } catch (error) {
    return error.response;
  }
};

export const updateletDetails = async (data) => {
  let user = JSON.parse(localStorage.getItem("userDetails"));
  try {
    const updateoutletDetailsData = await axios.post(
      `${FIS_BACKEND}/updateOutlet`,
      data,
      {
        headers: {
          "Content-Type": "multipart/form-data",
          Authorization: "Bearer " + user.accessToken,
        },
      }
    );
    return updateoutletDetailsData;
  } catch (error) {
    return error.response;
  }
};

//customer Master save
// export const saveCustomerDetails = async (data) => {
//    let user = JSON.parse(localStorage.getItem("userDetails"));
//   try {
//     const saveCustomerDetailsData = await axios.post(
//       `${FIS_BACKEND}/addCustomer`,
//       data,
//       {
//         headers: {
//           "Content-Type": "multipart/form-data",
//           Authorization: "Bearer " + user.accessToken,

//         },
//       }
//     );
//     return saveCustomerDetailsData;
//   } catch (error) {
//     return error.response;
//   }
// };

//customer Master update
// export const updateCustomerDetails = async (data) => {
//    let user = JSON.parse(localStorage.getItem("userDetails"));
//   try {
//     const updateCustomerDetailsData = await axios.post(
//       `${FIS_BACKEND}/updateCustomer`,
//       data,
//       {
//         headers: {
//           "Content-Type": "multipart/form-data",
//           Authorization: "Bearer " + user.accessToken,
//         },
//       }
//     );
//     return updateCustomerDetailsData;
//   } catch (error) {
//     return error.response;
//   }
// };

export const getDeliveryslotListMaster = async (outletId) => {
  try {
    const getMlmfuserlist = await axios.get(
      `${FIS_BACKEND}/api/auth/getAllDeliverySlotByOutlet?outletId=${outletId}`,
      {
        headers: authHeader(),
      }
    );
    return getMlmfuserlist;
  } catch (error) {
    return error.response;
  }
};

export const getOutletListMaster = async (outletId) => {
  try {
    const getMlmfuserlist = await axios.get(
      `${FIS_BACKEND}/getFilterId?outletId=${outletId}`,
      {
        headers: authHeader(),
      }
    );
    return getMlmfuserlist;
  } catch (error) {
    return error.response;
  }
};

export const updateCustomerDetails = async (data) => {
  try {
    const CustomerDetails = await axios.post(
      `${FIS_BACKEND}/updateCustomer`,
      { data },
      {
        headers: authHeader(),
      }
    );
    return CustomerDetails;
  } catch (error) {
    return error.response;
  }
};
export const broadcastAddContact = async (data) => {
  try {
    const contactDetails = await axios.post(
      `${FIS_BACKEND}/saveBroadcastContact`,
      data,  
      {
        headers: authHeader(), 
      }
    );
    return contactDetails.data; 
  } catch (error) {
    console.error('Error adding contact:', error);
    throw error; 
  }
};
//Image upload save s3 bucket

export const updateImagebucket = async (data) => {
  try {
    const CustomerDetails = await axios.post(
      `${FIS_BACKEND}/uploadFiles`,
      data,
      {
        "Content-Type": "multipart/form-data",
        headers: authHeader(),
      }
    );
    return CustomerDetails;
  } catch (error) {
    return error.response;
  }
};

//MLMF Menu List
export const getMlmfuserMaster = async () => {
  try {
    const getMlmfuserlist = await axios.get(`${FIS_BACKEND}/getMlmfUsers`, {
      headers: authHeader(),
    });
    return getMlmfuserlist;
  } catch (error) {
    return error.response;
  }
};

// Menu Mlmf outlet list

export const getMlmfoutletMaster = async () => {
  try {
    const getMlmfoutletlist = await axios.get(
      `${FIS_BACKEND}/getMlmfRestaurant`,
      {
        headers: authHeader(),
      }
    );
    return getMlmfoutletlist;
  } catch (error) {
    return error.response;
  }
};

export const getTemplatemsgMaster = async () => {
  try {
    const getMlmfoutletlist = await axios.get(
      `${FIS_BACKEND}/getWhatsappTemplate`,
      {
        headers: authHeader(),
      }
    );
    return getMlmfoutletlist;
  } catch (error) {
    return error.response;
  }
};



export const getContactMasterReq = async () => {
  try {
    const getMlmfoutletlist = await axios.get(
      `${FIS_BACKEND}/getContactMaster`,
      {
        headers: authHeader(),
      }
    );
    return getMlmfoutletlist;
  } catch (error) {
    return error.response;
  }
};



export const getBroadcastMasterReq = async () => {
  try {
    const getMlmfoutletlist = await axios.get(
      `${FIS_BACKEND}/getBroadcastList`,
      {
        headers: authHeader(),
      }
    );
    return getMlmfoutletlist;
  } catch (error) {
    return error.response;
  }
};


export const getLanguageMaster = async () => {
  try {
    const getMlmfoutletlist = await axios.get(
      `${FIS_BACKEND}/getLanguageMaster`,
      {
        headers: authHeader(),
      }
    );
    return getMlmfoutletlist;
  } catch (error) {
    return error.response;
  }
};

export const getHeadTypeMaster = async () => {
  try {
    const getMlmfoutletlist = await axios.get(
      `${FIS_BACKEND}/getHeaderTypeMaster`,
      {
        headers: authHeader(),
      }
    );
    return getMlmfoutletlist;
  } catch (error) {
    return error.response;
  }
};

export const getcustomerAdrsIDMaster = async (customerId) => {
  try {
    const getMlmfoutletlist = await axios.get(
      `${FIS_BACKEND}/getMlmfAddressByCustomerId?customerId=${customerId}`,
      {
        headers: authHeader(),
      }
    );
    return getMlmfoutletlist;
  } catch (error) {
    return error.response;
  }
};

export const getresbasedmenumaster = async (restaurantId) => {
  try {
    const getMlmfoutletlist = await axios.get(
      `${FIS_BACKEND}/getMlmfMenuByRestaurantId?restaurantId=${restaurantId}`,
      {
        headers: authHeader(),
      }
    );
    return getMlmfoutletlist;
    // console.log("getMlmfoutletlist",getMlmfoutletlist);
  } catch (error) {
    return error.response;
  }
};

//popular mane list
export const getresbasedPopularMenumaster = async (restaurantId) => {
  try {
    const getMlmfoutletlist = await axios.get(
      `${FIS_BACKEND}/getMlmfPopularMenuByRestaurantId?restaurantId=${restaurantId}`,
      {
        headers: authHeader(),
      }
    );
    return getMlmfoutletlist;
    // console.log("getMlmfoutletlist",getMlmfoutletlist);
  } catch (error) {
    return error.response;
  }
};

//Menu mlmf outlet menu
export const getsubscriptionlistApi = async (restaurantId, customerId) => {
  try {
    const getmenulist = await axios.get(
      `${FIS_BACKEND}/api/auth/getMlmfSchemeSubscriptionDetails?outletId=${restaurantId}&customerId=${customerId}`,
      {
        headers: authHeader(),
      }
    );
    return getmenulist;
  } catch (error) {
    return error.response;
  }
};

export const downloadTemplateExcelDownloadSubscription = async (
  fromDate,
  toDate,
  outletId
) => {
  try {
    const downloadCouponMasterTemplate = await axios.get(
      `${FIS_BACKEND}/api/auth/downloadCustomerSubcriptionData?fromDate=${fromDate}&toDate=${toDate}&outletId=${outletId}`,
      {
        responseType: "blob", // this is important!
        headers: authHeader(),
      }
    );
    return downloadCouponMasterTemplate;
  } catch (error) {
    // console.log("errorwresponse" + error);
    return error.response;
  }
};

export const getDailyplanListMaster = async (restaurantId) => {
  try {
    const getMlmfoutletlist = await axios.get(
      `${FIS_BACKEND}/getMlmfDailyPlanner?restaurantId=${restaurantId}`,
      {
        headers: authHeader(),
      }
    );
    return getMlmfoutletlist;
  } catch (error) {
    return error.response;
  }
};

export const getFreeDeliveryListMaster = async (restaurantId, customerId) => {
  try {
    const getMlmfoutletlist = await axios.get(
      `${FIS_BACKEND}/getMlmfFreeDelivery?restaurantId=${restaurantId}&customerId=${customerId}`,
      {
        headers: authHeader(),
      }
    );
    return getMlmfoutletlist;
  } catch (error) {
    return error.response;
  }
};

// staff management
export const gettstaffListMaster = async () => {
  try {
    const getStaffoutletmaslist = await axios.get(
      `${FIS_BACKEND}/api/auth/getUsersList`,
      {
        headers: authHeader(),
      }
    );
    return getStaffoutletmaslist;
  } catch (error) {
    return error.response;
  }
};

export const getMenuMasterList = async (outletCode) => {
  try {
    const getMenumasterlist = await axios.post(
      `${FIS_BACKEND}/findMenuByOutletCode?outletCode=${
        adminToMangerOutletCode || outletCode
      }`,
      {},
      {
        headers: authHeader(),
      }
    );
    return getMenumasterlist;
  } catch (error) {
    return error.response;
  }
};

//WhatsApp integration Api
export const sendWhatapp = async (data) => {
  try {
    const getMenumasterlist = await axios.post(
      `https://ucp.clsslabs.com/whatsappService/whatsapp/sendMessage`,

      // `${FIS_BACKEND}/findMenuByOutletCode?outletCode=${adminToMangerOutletCode || outletCode}`,
      {},
      {
        headers: {
          APIKEY: "ad0cbb90a252228927e5bb6f6cff15dc",
          Authorization:
            "Basic YWRoaXRoeWFuLm1AY2xzc2xhYnMuY29tOmFkaGl0aHlhbg==",
        },
      }
    );
    return getMenumasterlist;
  } catch (error) {
    return error.response;
  }
};

export const savestaffDetails = async (data) => {
  try {
    const savestaffData = await axios.post(
      `${FIS_BACKEND}/api/auth/Registration`,
      data,
      {
        headers: authHeader(),
      }
    );
    return savestaffData;
  } catch (error) {
    return error.response;
  }
};

export const saveDailyplanMenuREQ = async (data) => {
  //console.log("dataapi",data);
  try {
    const savestaffData = await axios.post(
      `${FIS_BACKEND}/saveMlmfDailyPlanner`,
      data,
      {
        headers: authHeader(),
      }
    );
    return savestaffData;
  } catch (error) {
    return error.response;
  }
};

export const saveFreeDeliveryREQ = async (data) => {
  //console.log("dataapi",data);
  try {
    const savestaffData = await axios.post(
      `${FIS_BACKEND}/saveMlmfFreeDelivery`,
      data,
      {
        headers: authHeader(),
      }
    );
    return savestaffData;
  } catch (error) {
    return error.response;
  }
};

export const saveCustomerDetails = async (data) => {
  try {
    const CustomerDetails = await axios.post(
      `${FIS_BACKEND}/addCustomer`,
      data,
      {
        headers: authHeader(),
      }
    );
    return CustomerDetails;
  } catch (error) {
    return error.response;
  }
};

export const staffUpdateUserDetails = async (data) => {
  try {
    const savestaffData = await axios.post(
      `${FIS_BACKEND}/api/auth/UpdateUser`,
      data,
      {
        headers: authHeader(),
      }
    );
    return savestaffData;
  } catch (error) {
    return error.response;
  }
};

export const updatePWDstaffDetails = async (
  compCode,
  outletCode,
  password,
  userId
) => {
  try {
    const savestaffData = await axios.post(
      `${FIS_BACKEND}/api/auth/changePassword?compCode=${
        adminToMangerCompanyCode || compCode
      }&outletCode=${
        adminToMangerOutletCode || outletCode
      }&password=${password}&userId=${userId}`,
      {},
      {
        headers: authHeader(),
      }
    );
    return savestaffData;
  } catch (error) {
    return error.response;
  }
};

export const resetPWDDetails = async (compCode, outletCode, userId) => {
  try {
    const savestaffData = await axios.post(
      `${FIS_BACKEND}/resetPassword?compCode=${
        adminToMangerCompanyCode || compCode
      }&outletCode=${adminToMangerOutletCode || outletCode}&userId=${userId}`,
      {},
      {
        headers: authHeader(),
      }
    );
    return savestaffData;
  } catch (error) {
    return error.response;
  }
};

//add outlet timing//
export const GetOutletTimingList = async (outletCode) => {
  try {
    const getoutletmaslist = await axios.get(
      `${FIS_BACKEND}/getOutletTiming?outletCode=${
        adminToMangerOutletCode || outletCode
      }`,
      {
        headers: authHeader(),
      }
    );
    return getoutletmaslist;
  } catch (error) {
    return error.response;
  }
};

export const saveOutletTiming = async (data) => {
  try {
    const saveoutletData = await axios.post(
      `${FIS_BACKEND}/addOutletTiming`,
      data,
      {
        headers: authHeader(),
      }
    );
    return saveoutletData;
  } catch (error) {
    return error.response;
  }
};

export const UpdateOutletTiming = async (data) => {
  try {
    const updateoutlet = await axios.post(
      `${FIS_BACKEND}/updateOutletTiming`,
      data,
      {
        headers: authHeader(),
      }
    );
    return updateoutlet;
  } catch (error) {
    return error.response;
  }
};

export const saveMainMenuName = async (data) => {
  try {
    const savestaffData = await axios.post(
      `${FIS_BACKEND}/addOutletMenu`,
      data,
      {
        headers: authHeader(),
      }
    );
    return savestaffData;
  } catch (error) {
    return error.response;
  }
};

export const saveSubMenuName = async (data) => {
  try {
    const savestaffData = await axios.post(
      `${FIS_BACKEND}/addOutletSubMenu`,
      data,
      {
        headers: authHeader(),
      }
    );
    return savestaffData;
  } catch (error) {
    return error.response;
  }
};

export const UpdateMenuName = async (data) => {
  try {
    const updatemenuname = await axios.post(
      `${FIS_BACKEND}/UpdateOutletMenu`,
      data,
      {
        headers: authHeader(),
      }
    );
    return updatemenuname;
  } catch (error) {
    return error.response;
  }
};

export const UpdateSubMenuName = async (data) => {
  try {
    const updatesubmenuname = await axios.post(
      `${FIS_BACKEND}/UpdateOutletSubMenu`,
      data,
      {
        headers: authHeader(),
      }
    );
    return updatesubmenuname;
  } catch (error) {
    return error.response;
  }
};

export const getMenuAvailalbitListApi = async (
  outletCode,
  mainMenuId,
  subMenuId,
  menuId
) => {
  try {
    const savestaffData = await axios.post(
      `${FIS_BACKEND}/MenuAvililableList?outeletCode=${
        adminToMangerOutletCode || outletCode
      }&mainMenuId=${mainMenuId}&subMenuId=${subMenuId}&menuId=${menuId}`,
      {},
      {
        headers: authHeader(),
      }
    );
    return savestaffData;
  } catch (error) {
    return error.response;
  }
};

export const addOutletSubMenuItem = async (data) => {
  let user = JSON.parse(localStorage.getItem("userDetails"));
  try {
    const saveoutletDetailsData = await axios.post(
      `${FIS_BACKEND}/addOutletSubMenuItem`,
      data,
      {
        headers: {
          "Content-Type": "multipart/form-data",
          Authorization: "Bearer " + user.accessToken,
        },
      }
    );
    return saveoutletDetailsData;
  } catch (error) {
    return error.response;
  }
};

export const UpdateOutletSubMenuItem = async (data) => {
  let user = JSON.parse(localStorage.getItem("userDetails"));
  try {
    const saveoutletDetailsData = await axios.post(
      `${FIS_BACKEND}/UpdateOutletSubMenuItem`,
      data,
      {
        headers: {
          "Content-Type": "multipart/form-data",
          Authorization: "Bearer " + user.accessToken,
        },
      }
    );
    return saveoutletDetailsData;
  } catch (error) {
    return error.response;
  }
};
// slot master//
export const SlotMasterList = async (outletCode) => {
  try {
    const getslotlist = await axios.post(
      `${FIS_BACKEND}/outletSlotList?outeletCode=${
        adminToMangerOutletCode || outletCode
      }`,
      {},
      {
        headers: authHeader(),
      }
    );
    return getslotlist;
  } catch (error) {
    return error.response;
  }
};

export const saveslotmaster = async (data) => {
  try {
    const saveslot = await axios.post(`${FIS_BACKEND}/addSlot`, data, {
      headers: authHeader(),
    });
    return saveslot;
  } catch (error) {
    return error.response;
  }
};

export const updateslotmaster = async (data) => {
  try {
    const updateslot = await axios.post(`${FIS_BACKEND}/updateSlot`, data, {
      headers: authHeader(),
    });
    return updateslot;
  } catch (error) {
    return error.response;
  }
};

export const saveofMenuAVL = async (data) => {
  try {
    const savestaffData = await axios.post(
      `${FIS_BACKEND}/addMenuAvailability`,
      data,
      {
        headers: authHeader(),
      }
    );
    return savestaffData;
  } catch (error) {
    return error.response;
  }
};

//Whatapp APIS
export const sendWhatAppText = async (data) => {
  try {
    const saveText = await axios.post(
      `${FIS_BACKEND}/addMenuAvailability`,
      data,
      {
        headers: {
          ApiKey: "ad0cbb90a252228927e5bb6f6cff15dc",
          Authorization:
            "Basic YWRoaXRoeWFuLm1AY2xzc2xhYnMuY29tOmFkaGl0aHlhbg==",
        },
      }
    );
    return saveText;
  } catch (error) {
    return error.response;
  }
};

export const copyofMenuAVLnext = async (
  outletCode,
  dateformat,
  fomratdateid
) => {
  try {
    const copyofsavestaffData = await axios.post(
      `${FIS_BACKEND}/copyMenuAvailability?outletCode=${
        adminToMangerOutletCode || outletCode
      }&date=${dateformat}&dayId=${fomratdateid}`,
      {},
      {
        headers: authHeader(),
      }
    );
    return copyofsavestaffData;
  } catch (error) {
    return error.response;
  }
};

export const deleteodmenuAVL = async (data) => {
  try {
    const savestaffData = await axios.post(
      `${FIS_BACKEND}/deleteMenuAvailability`,
      data,
      {
        headers: authHeader(),
      }
    );
    return savestaffData;
  } catch (error) {
    return error.response;
  }
};

export const updateMenuAvailabilityREQ = async (data) => {
  try {
    const savestaffData = await axios.post(
      `${FIS_BACKEND}/updateMenuAvailability`,
      data,
      {
        headers: authHeader(),
      }
    );
    return savestaffData;
  } catch (error) {
    return error.response;
  }
};

export const MenuList = async (compCode, outletCode) => {
  try {
    const getmenulist = await axios.get(
      `${FIS_BACKEND}/fetchOutletItem?compCode=${
        adminToMangerCompanyCode || compCode
      }&outletCode=${adminToMangerOutletCode || outletCode}`,
      {
        headers: authHeader(),
      }
    );
    return getmenulist;
  } catch (error) {
    return error.response;
  }
};

export const PaymentList = async (outletCode) => {
  try {
    const getpaymentlist = await axios.get(
      `${FIS_BACKEND}/order/getPayments?outletCode=${
        adminToMangerOutletCode || outletCode
      }`,
      {
        headers: authHeader(),
      }
    );
    return getpaymentlist;
  } catch (error) {
    return error.response;
  }
};

// export const downloadTemplateExcelDownload = async (cusId) => {
//   try {
//     const downloadTemplateExcelDownloadewresponse = await axios.get(
//       `${FIS_BACKEND}/download/downloadExcelTemplate?cusId=${cusId}`,
//       {
//         responseType: "blob", // this is important!
//         headers: authHeader(),
//       }
//     );
//     return downloadTemplateExcelDownloadewresponse;
//   } catch (error) {
//     // console.log("errorwresponse" + error);
//     return error.response;
//   }
// };


export const downloadTemplateExcelDownload = async (sample) => {
  try {
    const downloadTemplateExcelDownloadewresponse = await axios.get(
      `${FIS_BACKEND}/download?sample=${sample}`,
      {
        responseType: "blob", // this is important!
        headers: authHeader(),
      }
    );
    return downloadTemplateExcelDownloadewresponse;
  } catch (error) {
    // console.log("errorwresponse" + error);
    return error.response;
  }
};

// export const contactmasterexcelfileuploadcall = async (data) => {
//  debugger
//   try {
//     const Getcsvuploadfilestatemaster = await axios.post(
//       `${FIS_BACKEND}/uploadFile`,
//       data,
//       {
//         headers: {
//           Authorization: authHeader(),
//         },
//       }
//     );
//     return Getcsvuploadfilestatemaster;
//   } catch (error) {
//     // console.log("Getcsvuploadfilecitymaster" + error);
//     return error?.response;
//   }
// };


export const contactmasterexcelfileuploadcall = async (data) => {
  try {
    const savestaffData = await axios.post(
      `${FIS_BACKEND}/uploadFile`,
      data,
      {
        "Content-Type": "multipart/form-data",
        headers: authHeader(),
      }
    );
    return savestaffData;
  } catch (error) {
    return error.response;
  }
};

export const fetchOutletItemCategoryApiReq = async (compCode, outletCode) => {
  try {
    const fetchOutletItemCategoryapi = await axios.get(
      `${FIS_BACKEND}/fetchOutletItemCategory?compCode=${
        adminToMangerCompanyCode || compCode
      }&outletCode=${adminToMangerOutletCode || outletCode}`,
      {
        headers: authHeader(),
      }
    );
    return fetchOutletItemCategoryapi;
  } catch (error) {
    return error.response;
  }
};

export const weeekMasterApiCallREQ = async (outletCode, weekType) => {
  try {
    const getmenulist = await axios.post(
      `${FIS_BACKEND}/weeklyMenuList?outletCode=${
        adminToMangerOutletCode || outletCode
      }&weekType=${weekType}`,
      {},
      {
        headers: authHeader(),
      }
    );
    return getmenulist;
  } catch (error) {
    return error.response;
  }
};

export const downloadTodaymenuMasterApiCallREQ = async (
  outletCode,
  dayId,
  outletDate
) => {
  try {
    const getmenulist = await axios.get(
      `${FIS_BACKEND}/jasper/downloadMenuByDayPDF?outletCode=${
        adminToMangerOutletCode || outletCode
      }&dayId=${dayId}&outletDate=${outletDate}`,
      {
        responseType: "blob",
        headers: authHeader(),
      }
    );
    return getmenulist;
  } catch (error) {
    return error.response;
  }
};

export const slotWisedownloadTodaymenuMasterApiCallREQ = async (
  outletCode,
  todayId,
  slotId,
  outletDate
) => {
  try {
    const getmenulist = await axios.get(
      `${FIS_BACKEND}/jasper/downloadMenuBySlotPDF?outletCode=${
        adminToMangerOutletCode || outletCode
      }&dayId=${todayId}&slotId=${slotId}&outletDate=${outletDate}`,
      {
        responseType: "blob",
        headers: authHeader(),
      }
    );
    return getmenulist;
  } catch (error) {
    return error.response;
  }
};

export const viewTodaymenuMasterApiCallREQ = async (
  outletCode,
  dayId,
  outletDate
) => {
  try {
    const getmenulist = await axios.get(
      `${FIS_BACKEND}/jasper/viewMenuByDayPDF?outletCode=${
        adminToMangerOutletCode || outletCode
      }&dayId=${dayId}&outletDate=${outletDate}`,
      {
        responseType: "blob",
        headers: authHeader(),
      }
    );
    return getmenulist;
  } catch (error) {
    return error.response;
  }
};

export const viewTodaymenuslotwiseCallREQ = async (
  outletCode,
  todayId,
  slotId,
  outletDate
) => {
  try {
    const getmenulist = await axios.get(
      `${FIS_BACKEND}/jasper/viewMenuBySlotPDF?outletCode=${
        adminToMangerOutletCode || outletCode
      }&dayId=${todayId}&slotId=${slotId}&outletDate=${outletDate}`,
      {
        responseType: "blob",
        headers: authHeader(),
      }
    );
    return getmenulist;
  } catch (error) {
    return error.response;
  }
};

// turn of availablity against the day and the day's slot

export const apiReqOnOffDaySlot = async (
  dayId,
  outletCode,
  slotId,
  todayDate,
  status,
  mlmfCategoryId
) => {
  try {
    const daySlotOnOffReq = await axios.post(
      `${FIS_BACKEND}/OnOffDaySlot?dayId=${dayId}&outletCode=${
        adminToMangerOutletCode || outletCode
      }&slotId=${slotId}&todayDate=${todayDate}&status=${status}&mlmfCategoryId=${mlmfCategoryId}`,
      {},
      {
        headers: authHeader(),
      }
    );
    return daySlotOnOffReq;
  } catch (error) {
    return error.response;
  }
};

export const menuPlanListAPICALL = async (outeletCode, todayDate) => {
  try {
    const getmenulist = await axios.post(
      `${FIS_BACKEND}/menuPlanList?outeletCode=${outeletCode}&date=${todayDate}`,
      {},
      {
        headers: authHeader(),
      }
    );
    return getmenulist;
  } catch (error) {
    return error.response;
  }
};

export const menuCategoryMasterList = async (outletCode) => {
  try {
    const getmenulist = await axios.get(
      `${FIS_BACKEND}/getOutletMenu?outletCode=${
        adminToMangerOutletCode || outletCode
      }`,
      {
        headers: authHeader(),
      }
    );
    return getmenulist;
  } catch (error) {
    return error.response;
  }
};

export const submenuCategoryMasterList = async (outletCode, mainMenuId) => {
  try {
    const getmenulist = await axios.get(
      `${FIS_BACKEND}/getOutletSubMenu?outletCode=${
        adminToMangerOutletCode || outletCode
      }&mainMenuId=${mainMenuId}`,
      {
        headers: authHeader(),
      }
    );
    return getmenulist;
  } catch (error) {
    return error.response;
  }
};

export const subscriptionPlanId = async (outletCode) => {
  try {
    const getmenulist = await axios.get(
      `${FIS_BACKEND}/api/auth/getMlmfSchemePlanDetails?outletId=${outletCode}`,
      {
        headers: authHeader(),
      }
    );
    return getmenulist;
  } catch (error) {
    return error.response;
  }
};

export const subscriptionWalletAmount = async (customerId) => {
  try {
    const getmenulist = await axios.get(
      `${FIS_BACKEND}/api/auth/getActualWalletAmount?customerId=${customerId}`,
      {
        headers: authHeader(),
      }
    );
    return getmenulist;
  } catch (error) {
    return error.response;
  }
};

export const subscriptionReportsList = async (outletCode, fromdate, todate) => {
  try {
    const getmenulist = await axios.get(
      `${FIS_BACKEND}/api/auth/getMlmfSchemeSubscriptionReport?fromDate=${fromdate}&toDate=${todate}&outletId=${outletCode}`,
      {
        headers: authHeader(),
      }
    );
    return getmenulist;
  } catch (error) {
    return error.response;
  }
};

export const addOutletItem = async (data) => {
  let user = JSON.parse(localStorage.getItem("userDetails"));
  try {
    const saveOutletItem = await axios.post(
      `${FIS_BACKEND}/addOutletItem`,
      data,
      {
        headers: {
          "Content-Type": "multipart/form-data",
          Authorization: "Bearer " + user.accessToken,
        },
      }
    );
    return saveOutletItem;
  } catch (error) {
    return error.response;
  }
};

export const UpdateOutletItem = async (data) => {
  let user = JSON.parse(localStorage.getItem("userDetails"));
  try {
    const updateoutletitem = await axios.post(
      `${FIS_BACKEND}/updateOutletItem`,
      data,
      {
        headers: {
          "Content-Type": "multipart/form-data",
          Authorization: "Bearer " + user.accessToken,
        },
      }
    );
    return updateoutletitem;
  } catch (error) {
    return error.response;
  }
};

export const saveMlmfCustomerMenuREQ = async (data) => {
  //console.log("data",data);
  let user = JSON.parse(localStorage.getItem("userDetails"));
  try {
    const savesubcription = await axios.post(
      `${FIS_BACKEND}/api/auth/saveMlmfSchemeSubscriptionData`,
      data,
      {
        headers: authHeader(),
      }
    );
    return savesubcription;
  } catch (error) {
    return error.response;
  }
};

export const updateMlmfCustomerMenuReq = async (data) => {
  let user = JSON.parse(localStorage.getItem("userDetails"));

  console.log("updatedata", data);
  try {
    const savesubcription = await axios.post(
      `${FIS_BACKEND}/api/auth/updateMlmfSchemeSubscriptionData`,
      data,
      {
        headers: authHeader(),
      }
    );
    return savesubcription;
  } catch (error) {
    return error.response;
  }
};

export const saveMlmfCustomerWalletREQ = async (data) => {
  // console.log("data",data);
  let user = JSON.parse(localStorage.getItem("userDetails"));
  //  return false;
  try {
    const savesubcription = await axios.post(
      `${FIS_BACKEND}/saveMlmfWallet`,
      data,
      {
        headers: authHeader(),
      }
    );
    return savesubcription;
  } catch (error) {
    return error.response;
  }
};

export const updateMlmfCustomerWalletReq = async (data) => {
  let user = JSON.parse(localStorage.getItem("userDetails"));
  try {
    const savesubcription = await axios.post(
      `${FIS_BACKEND}/updateMlmfWallet`,
      data,
      {
        headers: authHeader(),
      }
    );
    return savesubcription;
  } catch (error) {
    return error.response;
  }
};

export const deletesubscriptionmenuitem = async (data) => {
  try {
    const savestaffData = await axios.post(
      `${FIS_BACKEND}/deleteMlmfCustomerMenu`,
      data,
      {
        headers: authHeader(),
      }
    );
    return savestaffData;
  } catch (error) {
    return error.response;
  }
};

export const deleteDailyplanerREQ = async (data) => {
  // console.log("data",data);

  try {
    const savestaffData = await axios.post(
      `${FIS_BACKEND}/deleteMlmfDailyPlannerById`,
      data,
      {
        headers: authHeader(),
      }
    );
    return savestaffData;
  } catch (error) {
    return error.response;
  }
};

export const multideleteDailyplanerREQ = async (data) => {
  //console.log("data",data);

  try {
    const savestaffData = await axios.post(
      `${FIS_BACKEND}/deleteMlmfDailyPlanner`,
      data,
      {
        headers: authHeader(),
      }
    );
    return savestaffData;
  } catch (error) {
    return error.response;
  }
};

export const getcustomerwalletlist = async (customerId) => {
  try {
    const getpaymentlist = await axios.get(
      `${FIS_BACKEND}/getCustomerWalletHistory?customerId=${customerId}`,
      {
        headers: authHeader(),
      }
    );
    return getpaymentlist;
  } catch (error) {
    return error.response;
  }
};

export const getcustomerDeliverypointlist = async (delPointCode) => {
  try {
    const getpaymentlist = await axios.get(
      `${FIS_BACKEND}/getMlmfDeliveryPoint?delPointCode=${delPointCode}`,
      {
        headers: authHeader(),
      }
    );
    return getpaymentlist;
  } catch (error) {
    return error.response;
  }
};

export const saveDeliverypointREQ = async (data) => {
  // console.log("data2",data);
  let user = JSON.parse(localStorage.getItem("userDetails"));

  try {
    const savedeliverypoint = await axios.post(
      `${FIS_BACKEND}/saveMlmfDeliveryPoint`,
      data,
      {
        headers: authHeader(),
      }
    );
    return savedeliverypoint;
  } catch (error) {
    return error.response;
  }
};

export const updateDeliveryPointReq = async (data) => {
  let user = JSON.parse(localStorage.getItem("userDetails"));

  try {
    const savesubcription = await axios.post(
      `${FIS_BACKEND}/UpdateMlmfDeliveryPoint`,
      data,
      {
        headers: authHeader(),
      }
    );
    return savesubcription;
  } catch (error) {
    return error.response;
  }
};

export const deleteDeliverypointREQ = async (delPointCode, status) => {
  try {
    const deletedelpoint = await axios.post(
      `${FIS_BACKEND}/deleteMlmfDeliveryPoint?delPointCode=${delPointCode}&status=${status}`,
      {},
      {
        headers: authHeader(),
      }
    );
    return deletedelpoint;
  } catch (error) {
    return error.response;
  }
};

export const AprovalpointREQ = async (templatedId, approvedFlag) => {
  
  try {
    const deletedelpoint = await axios.post(
      `${FIS_BACKEND}/updateAppFlagByTemplatedId?templatedId=${templatedId}&approvedFlag=${approvedFlag}`,
      {},
      {
        headers: authHeader(),
      }
    );
    return deletedelpoint;
  } catch (error) {
    return error.response;
  }
};

export const CatgorysubList = async (outletCode) => {
  try {
    const getcategorylist = await axios.post(
      `${FIS_BACKEND}/getCatSubCatList?outletCode=${
        adminToMangerOutletCode || outletCode
      }`,
      {},
      {
        headers: authHeader(),
      }
    );
    return getcategorylist;
  } catch (error) {
    return error.response;
  }
};

export const deletecategory = async (data) => {
  try {
    const savestaffData = await axios.post(
      `${FIS_BACKEND}/deleteItemCategoryMap`,
      data,
      {
        headers: authHeader(),
      }
    );
    return savestaffData;
  } catch (error) {
    return error.response;
  }
};

// master data//
export const UomList = async (data) => {
  try {
    const getuomlist = await axios.post(`${FIS_BACKEND}/getUomList`, data, {
      headers: authHeader(),
    });
    return getuomlist;
  } catch (error) {
    return error.response;
  }
};

export const getUserByOutletREQ = async (compCode, outletCode) => {
  try {
    const getUserByOutletData = await axios.post(
      `${FIS_BACKEND}/api/auth/getUserByOutlet?compCode=${
        adminToMangerCompanyCode || compCode
      }&outletCode=${adminToMangerOutletCode || outletCode}`,
      {},
      {
        headers: authHeader(),
      }
    );
    return getUserByOutletData;
  } catch (error) {
    return error.response;
  }
};

export const UpdateCategoryItem = async (
  categoryId,
  compCode,
  itemId,
  outletCode,
  subCategoryId
) => {
  try {
    const updatecategoryitem = await axios.post(
      `${FIS_BACKEND}/updateItemCatMap?categoryId=${categoryId}&compCode=${
        adminToMangerCompanyCode || compCode
      }&itemId=${itemId}&outletCode=${
        adminToMangerOutletCode || outletCode
      }&subCategoryId=${subCategoryId}`,
      {},
      {
        headers: authHeader(),
      }
    );
    return updatecategoryitem;
  } catch (error) {
    return error.response;
  }
};

export const deletemenuitem = async (compCode, outletCode, menuId) => {
  try {
    const deletemenuitem = await axios.post(
      `${FIS_BACKEND}/deleteMenu?compCode=${
        adminToMangerCompanyCode || compCode
      }&outletCode=${adminToMangerOutletCode || outletCode}&menuId=${menuId}`,
      {},
      {
        headers: authHeader(),
      }
    );
    return deletemenuitem;
  } catch (error) {
    return error.response;
  }
};

export const broadcast_whatsapp_call = async (data_dynamic, url_dynamic) => {
  // console.log(data_dynamic);
  // return false;
  try {
    const saveoutletDetailsData = await axios.post(
      `${ucp_BACKEND}/${url_dynamic}`,
      data_dynamic,
      {
        headers: {
          "Content-Type": "application/json",
          APIKEY: `${APIKEY_TOKEN}`,
          Authorization: "Basic " + base64.encode(username1 + ":" + password1),
        },
      }
    );
    return saveoutletDetailsData;
  } catch (error) {
    return error.response;
  }
};

// Add a response interceptor
axios.interceptors.response.use(
  function (response) {
    return response;
  },
  function (error) {
    if (error.response.status === 401) {
      // alert("401")
      console.error("TOKEN EXPIRED 401");
      localStorage.clear();
      window.location.replace("#/login");
      window.location.reload(true);

      // } else if (error.response.status === 500) {
      // } else if (error.response.status === 403) {
      // } else if (error.response.status === 413) {
      // } else if (error.response.status === 404) {
      // } else if (error.response.status === 504) {
    }
    return Promise.reject(error);
  }
);
